// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import './rem.js'
import './assets/main.css'
// import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import global from './utils/global'

import http from './utils/http.js'
import api from './utils/api.js'
Vue.prototype.http = http
Vue.prototype.api = api
Vue.prototype.global = global
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js